import { all } from 'redux-saga/effects';
import apiSaga from './apiSaga';
import userSagas from './userSagas';
import authSagas from './authSagas';
import answerSagas from './answerSagas';
import questionBlockSagas from './questionBlockSagas';
import recommendationsSagas from './recommendationsSagas';
import summarySagas from './summarySagas';
import filteringSagas from './filteringSagas';
import searchTagsSaga from './tagSagas';
import hiddenTagSagas from './hiddenTagSagas';
import recommendationHidingSagas from './recommendationHidingSagas';
import resultSagas from './resultSagas';
import oauthSagas from './oauthSagas';

// Long running sagas:
import eternalSagas from './eternalSagas';

export default function* rootSaga() {
  yield all([
    apiSaga,
    searchTagsSaga,
    ...userSagas,
    ...authSagas,
    ...answerSagas,
    ...questionBlockSagas,
    ...recommendationsSagas,
    ...summarySagas,
    ...filteringSagas,
    ...hiddenTagSagas,
    ...recommendationHidingSagas,
    ...resultSagas,
    ...oauthSagas,
    // These have to go last!!
    ...eternalSagas,
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js